import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import { Card } from '@components/common';
import Icon from '@components/Icon/Icon';
import './RefillCard.scss';

const RefillCard = ({ refill, displayType = 'grid', onClick, actions }) => {
    const { t } = useLanguage();

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const handleClick = () => {
        if (onClick) {
            onClick(refill);
        }
    };

    if (displayType === 'list') {
        return (
            <div className="refill-card refill-card--list" onClick={handleClick}>
                <div className="refill-card__content">
                    <div className="refill-card__left">
                        <div className="refill-card__icon">
                            <Icon icon="arrow-up" size="lg" color="#5DADE2" />
                        </div>
                        <div className="refill-card__info">
                            {refill.resource?.name && (
                                <h4 className="refill-card__resource">
                                    {refill.resource?.name}
                                </h4>
                            )}
                            <div className="refill-card__detail-item">
                                <Icon icon="user" className="refill-card__detail-icon" />
                                <span className="refill-card__detail-text">
                                    {refill.user?.name || refill.user?.email || t('refill.unknown_user')}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="refill-card__right">
                        <div className="refill-card__date">
                            <Icon icon="calendar" className="refill-card__date-icon" />
                            <span className="refill-card__date-text">
                                {formatDate(refill.refilled_at)}
                            </span>
                        </div>
                        <div className="refill-card__quantity">
                            <span className="refill-card__quantity-value">
                                +{refill.quantity_added}
                            </span>
                            <span className="refill-card__quantity-unit">
                                {t('refill.units')}
                            </span>
                        </div>
                    </div>
                    {actions && (
                        <div className="refill-card__actions">
                            {actions}
                        </div>
                    )}
                </div>
                {refill.notes && (
                    <div className="refill-card__notes">
                        <Icon icon="file-alt" className="refill-card__notes-icon" />
                        <p className="refill-card__notes-text">{refill.notes}</p>
                    </div>
                )}
            </div>
        );
    }

    // Grid display (default)
    return (
        <Card className="refill-card refill-card--grid" onClick={handleClick} hoverable>
            <div className="refill-card__content">
                <div className="refill-card__header">
                    <div className="refill-card__info">
                        <h4 className="refill-card__resource">
                            {refill.resource?.name || t('refill.unknown_resource')}
                        </h4>
                        <div className="refill-card__quantity">
                            <Icon icon="arrow-up" size="lg" />
                            <span className="refill-card__quantity-unit">
                               {refill.quantity_added} {t('refill.units')}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="refill-card__details">
                    <div className="refill-card__field">
                        <div className="refill-card__field-header">
                            <Icon icon="user" className="refill-card__field-icon" />
                            <span className="refill-card__value">
                                {refill.user?.name || refill.user?.email || t('refill.unknown_user')}
                            </span>
                        </div>
                    </div>

                    <div className="refill-card__field">
                        <div className="refill-card__field-header">
                            <Icon icon="calendar" className="refill-card__field-icon" />
                            <span className="refill-card__value">{formatDate(refill.refilled_at)}</span>
                        </div>
                    </div>
                </div>

                {refill.notes && (
                    <div className="refill-card__notes">
                        <p className="refill-card__value refill-card__notes-text">{refill.notes}</p>
                    </div>
                )}

                {actions && (
                    <div className="refill-card__actions">
                        {actions}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default RefillCard;
